import { render } from "./ProgresoSalud.vue?vue&type=template&id=dc78bbc6"
import script from "./ProgresoSalud.vue?vue&type=script&lang=js"
export * from "./ProgresoSalud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__